var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckAll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_533_10501)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.99999 14C3.7348 13.9999 3.48049 13.8945 3.29299 13.707L0.292993 10.707C0.10217 10.5228 -0.00766734 10.2703 -0.0123557 10.0052C-0.0170442 9.74 0.0838004 9.48382 0.267993 9.29299C0.452186 9.10217 0.704639 8.99233 0.969816 8.98765C1.23499 8.98296 1.49117 9.0838 1.68199 9.26799L1.70699 9.29299L3.87899 11.466L11.191 1.41199C11.3469 1.19743 11.5817 1.05361 11.8437 1.01217C12.1057 0.970721 12.3734 1.03505 12.588 1.19099C12.8026 1.34694 12.9464 1.58174 12.9878 1.84372C13.0293 2.10571 12.9649 2.37343 12.809 2.58799L4.80899 13.588C4.72427 13.7055 4.61502 13.8032 4.4888 13.8744C4.36258 13.9455 4.22241 13.9884 4.07799 14H3.99999Z",
    fill: "#5F1CCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 4H13.5C13.2239 4 13 4.22386 13 4.5V5.5C13 5.77614 13.2239 6 13.5 6H15.5C15.7761 6 16 5.77614 16 5.5V4.5C16 4.22386 15.7761 4 15.5 4Z",
    fill: "#5F1CCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 8H10.5C10.2239 8 10 8.22386 10 8.5V9.5C10 9.77614 10.2239 10 10.5 10H15.5C15.7761 10 16 9.77614 16 9.5V8.5C16 8.22386 15.7761 8 15.5 8Z",
    fill: "#5F1CCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 12H7.5C7.22386 12 7 12.2239 7 12.5V13.5C7 13.7761 7.22386 14 7.5 14H15.5C15.7761 14 16 13.7761 16 13.5V12.5C16 12.2239 15.7761 12 15.5 12Z",
    fill: "#5F1CCC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_533_10501"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckAll);
export default __webpack_public_path__ + "static/media/check-all.82bee2a6f9e43e43d466aacfa7f2a52d.svg";
export { ForwardRef as ReactComponent };